document.addEventListener('click', (e) => {
  const root = e.target.closest('[data-drawer-push-menu]');
  if (!root) return;

  const showMoreBtn = e.target.closest('[data-show-more-mobile]');
  if (showMoreBtn) return;

  // allow real links inside (L3, view all) to work normally
  const realLink = e.target.closest('a');
  if (realLink) return;

  const backBtn = e.target.closest('[data-back]');
  const active = root.querySelector('.dpm-screen.is-active');

  const item = e.target.closest('.dpm-item');

  if (item && item.hasAttribute('data-open-screen')) {
    const target = item.getAttribute('data-open-screen');
    const next = root.querySelector(`.dpm-screen[data-screen="${CSS.escape(target)}"]`);
    if (!next) return;

    const stack = JSON.parse(root.getAttribute('data-stack') || '["root"]');
    stack.push(target);
    root.setAttribute('data-stack', JSON.stringify(stack));

    active?.classList.remove('is-active');
    next.classList.add('is-active');
    return;
  }

  if (item && item.hasAttribute('data-toggle-accordion')) {
    const details = item.querySelector('details.dpm-accordion');
    if (!details) return;
    details.open = !details.open;
    return;
  }

  if (item && item.hasAttribute('data-url')) {
    const url = item.getAttribute('data-url');
    if (url) window.location.href = url;
    return;
  }

  if (backBtn) {
    const stack = JSON.parse(root.getAttribute('data-stack') || '["root"]');
    if (stack.length <= 1) return;

    stack.pop();
    const prevId = stack[stack.length - 1];
    root.setAttribute('data-stack', JSON.stringify(stack));

    active?.classList.remove('is-active');
    const prev = root.querySelector(`.dpm-screen[data-screen="${CSS.escape(prevId)}"]`);
    prev?.classList.add('is-active');
  }
});

document.addEventListener('click', function (event) {
  const toggleBtn = event.target.closest('[data-show-more-mobile]');
  if (!toggleBtn) return;

  event.preventDefault();

  const details = toggleBtn.closest('.dpm-accordion');
  if (!details) return;

  const list = details.querySelector('.dpm-sublist');
  if (!list) return;

  const isExpanded = list.classList.toggle('is-expanded');

  toggleBtn.setAttribute('aria-expanded', String(isExpanded));
  toggleBtn.textContent = isExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
});